import { academiesLocaleEn } from '../sections/Academies/i18n';
import { bundlesLocaleEn } from '../sections/Bundles/i18n';
import { careersLocaleEn } from '../sections/Careers/i18n';
import { coursesLocaleEn } from '../sections/Courses/i18n';
import { degreesLocaleEn } from '../sections/Degrees/i18n';
import { tracksLocaleEn } from '../sections/Tracks/i18n';

const localeEn = {
  en: {
    ...academiesLocaleEn,
    ...bundlesLocaleEn,
    ...careersLocaleEn,
    ...coursesLocaleEn,
    ...degreesLocaleEn,
    ...tracksLocaleEn,
  },
};

export default localeEn;
